import { useRecoilState, useRecoilValue } from "recoil";
import { useEffect, useMemo, useRef } from "react";
import { mapContentsVisibleWithID } from "../../../store/MapContentsState";
import { drawCoastLineOverContentsState } from "../../../store/DrawCoastLineOverContentsState";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";

function CoastLineDispatcher({contentsID, contents}) {
  const [visible, setVisible] = useRecoilState(mapContentsVisibleWithID(contentsID));
  const clState = useRecoilValue(drawCoastLineOverContentsState);
  const prevVisibleRef = useRef(visible);
  const autoChangeRef = useRef(false);
  const visibleDependency = useMemo(() => ([visible]), [visible]);
  const clDependency = useMemo(() => ([clState]), [clState]);

  useEffect(() => {
    if (visible || 0 < clState.length) {
      contents.drawLayer(true);
    } else {
      contents.drawLayer(false);
    }
    // eslint-disable-next-line
  }, []);

  useEffectSkipFirst(async() => {
    if (visible) {
      await contents.drawLayer(true);
    } else {
      await contents.drawLayer(false);
    }
    if (!autoChangeRef.current) {
      prevVisibleRef.current = visible;
    }
    autoChangeRef.current = false;
  }, visibleDependency);

  useEffectSkipFirst(() => {

    if (clState.length > 0) {
      if (!visible) {
        autoChangeRef.current = true;
      }
      setVisible(true);
      prevVisibleRef.current = visible;
    } else {
      if (visible !== prevVisibleRef.current) {
        autoChangeRef.current = true;
      }
      setVisible(prevVisibleRef.current);
    }
  }, clDependency);

  //dont draw anything
  return null;
}

export default CoastLineDispatcher;
